import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCreditCardFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 4H5a3 3 0 0 0-3 3v2h20V7a3 3 0 0 0-3-3Zm3 7H2v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6Zm-12 4a1 1 0 0 1 .117 1.993L10 17H6a1 1 0 0 1-.117-1.993L6 15h4Z", fill: color }));
};
export default factorySvgIcon(SvgCreditCardFilled);
//# sourceMappingURL=SvgCreditCardFilled.js.map